import axios from 'axios';
import apiConfig from '../api.config';

export default function googleAuthApi(data) {
  const {
    host,
    URIs: { googleAuthApi },
  } = apiConfig;

  const uri = `${host}${googleAuthApi}`;

  return axios
    .post(uri, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
